module.exports = __webpack_public_path__ + "assets/vehicle_map_sedan@2x.5b003caa.svg";